import React from "react";
import * as c from "./sliderPageLogo.module.scss";
import { MangomintLogo } from "@components/ui/mangomintLogo";
import classNames from "classnames";

export default function SliderPageLogo({ isHidden }) {
  return (
    <div className={classNames(c.logoCtn, { [c.isHidden]: isHidden })}>
      <MangomintLogo className={c.logoLink} />
    </div>
  );
}
